import type { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { ROLE_ADMIN } from '../../utils/constants';

interface AuthGuardProps {
  children: ReactNode;
  isAuthenticated: boolean;
  user: any;
}

const AuthGuard: FC<AuthGuardProps> = ({ children, isAuthenticated, user }) => {
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (location.pathname === '/admin') {
    const currentRole = user?.role?.name;
    if (currentRole) {
      const pathRedirect = `/admin/${
        currentRole === ROLE_ADMIN ? 'upload' : 'home'
      }`;
      return <Navigate to={pathRedirect} />;
    }
  }

  return <>{children}</>;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
});

export default connect(mapStateToProps, {})(AuthGuard);
